// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccionaAlert_wrapper__2SIhx"};